import { MicrosoftOnePageModel } from '../../../../../orchestration/microsoft/reports/models/microsoft-one-page-model';
import { ReportProfileRulesComputedDelegate } from '../../../../../models/profile/report-profile-rules-computed-delegate';
import { SharePointReportProfile } from '../../../../../models/microsoft/sharepoint/profile/share-point-report-profile';

export class SharePointOnePageModel extends MicrosoftOnePageModel {
  resourceProfile: SharePointReportProfile;
}
